import { useEffect, useRef } from 'react';

function RecentView() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const handleLoad = () => {
      const doc = iframe.contentDocument ?? iframe.contentWindow?.document;
      if (!doc) return;
      const header = doc.querySelector('header');
      const footer = doc.querySelector('footer');
      const breadcrumbs = doc.querySelector('.breadcrumbs');
      const headerGlobal = doc.querySelector('[data-content-region="above_header--global"]');
      // const b2b = doc.querySelector('.navBar-section');
      // const bar = doc.querySelector('.navBar');
      // const navBarAccount = doc.querySelector('.navBar--account');
      const container = doc.querySelector<HTMLElement>('.account-container');
      const nav = doc.querySelector('nav');
      const pageHeading = doc.querySelector('.page-heading');
      if (container) {
        container.style.paddingTop = '0px';
      }
      header?.remove();
      footer?.remove();
      breadcrumbs?.remove();
      headerGlobal?.remove();
      // b2b?.remove();
      // bar?.remove();
      // navBarAccount?.remove();
      nav?.remove();
      pageHeading?.remove();
    };

    iframe.addEventListener('load', handleLoad);
    return () => iframe.removeEventListener('load', handleLoad);
  }, []);

  return (
    <iframe
      ref={iframeRef}
      src="/account.php?action=recent_items"
      title="Bandeja de Entrada"
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
        display: 'block',
      }}
    />
  );
}
export default RecentView;
